export const HelpersUtil = {
    isLowerCaseMatch(str1, str2) {
        return str1?.toLowerCase() === str2?.toLowerCase();
    }
};
//# sourceMappingURL=HelpersUtil.js.map